import { useQueryClient } from '@tanstack/react-query';
import { UpdateUserMutation, useUpdateUserMutation, useUserQuery } from '../../../api/gql';

type UseUpdateUserProps = {
  onSuccess?: (data: UpdateUserMutation) => void;
  onError?: (status: number) => void;
};

export const useUpdateUser = (props?: UseUpdateUserProps) => {
  const client = useQueryClient();
  const { isPending, mutate } = useUpdateUserMutation({
    onSuccess: (res) => {
      client.setQueryData(useUserQuery.getKey(), {
        user: { ...res.updateUser },
      });
      props?.onSuccess?.(res);
    },
    onError: ({ code, message }) => {
      console.error(message);
      props?.onError?.(code);
    },
  });

  return {
    isPending,
    updateUser: mutate,
  };
};
